import { FunctionComponent, ReactNode, useState } from 'react'
import type { Layer } from 'leaflet'
import useParam from '../../hooks/useParam'
import MapContext, { MapState } from './MapContext'
import {
  legendOpenParam,
  locationParam,
  mapLayersParam,
  panoFullScreenParam,
  panoHeadingParam,
  showLargeMapParam,
} from '../../../pages/MapPage/query-params'
import type { InfoBoxProps } from '../../../pages/MapPage/legacy/types/details'
import useWindowWidth from '../../hooks/useWindowWidth'
import { Breakpoint } from '../../hooks/useBreakpoint'

const MapContainer: FunctionComponent<{ children: ReactNode }> = ({ children }) => {
  const [activeMapLayers] = useParam(mapLayersParam)
  const [activeEmbeddedMapLayers, setActiveEmbeddedMapLayers] = useState(activeMapLayers)
  const [location] = useParam(locationParam)
  const [panoHeading] = useParam(panoHeadingParam)
  const [legendParameter] = useParam(legendOpenParam)
  const [legendActive, setLegendActive] = useState(legendParameter)
  const [infoBox, setInfoBox] = useState<InfoBoxProps>()
  const [panoImageDate, setPanoImageDate] = useState<MapState['panoImageDate']>(null)
  const [showMapDrawVisualization, setShowMapDrawVisualization] = useState(false)
  const [panelHeader, setPanelHeader] = useState<MapState['panelHeader']>({ title: 'Resultaten' })
  const [panoFullScreen, setPanoFullScreen] = useParam(panoFullScreenParam)
  const [distanceText, setDistanceText] = useState<string>()
  const [drawToolLocked, setDrawToolLocked] = useState(false)
  const width = useWindowWidth()
  const isMobile = width < Breakpoint.Md.valueOf()
  const [showMap, setShowMap] = useState(true)
  const [featureLayers, setFeatureLayers] = useState<Layer[]>([])
  const [panelActive, setPanelActive] = useState(false)
  const [outOfBounds, setOutOfBounds] = useState(false)
  const [showLargeMap, setShowLargeMap] = useParam(showLargeMapParam)

  const panoActive = panoHeading !== null && location !== null

  return (
    <MapContext.Provider
      value={{
        featureLayers,
        setFeatureLayers,
        showLargeMap: showLargeMap || !panelActive || (isMobile && panoActive),
        setShowLargeMap,
        showMap,
        setShowMap,
        panelActive,
        setPanelActive,
        panoActive,
        panelHeader,
        activeEmbeddedMapLayers,
        setPanelHeader,
        panoFullScreen,
        setPanoFullScreen,
        showMapDrawVisualization,
        setShowMapDrawVisualization,
        setLegendActive,
        legendActive,
        infoBox,
        setInfoBox,
        setActiveEmbeddedMapLayers,
        outOfBounds,
        setOutOfBounds,
        panoImageDate,
        setPanoImageDate,
        drawToolLocked,
        setDrawToolLocked,
        distanceText,
        setDistanceText,
      }}
    >
      {children}
    </MapContext.Provider>
  )
}

export default MapContainer
